// Корекцията върху сметката, прочетена със знак: отстъпката е отнета сума,
// надбавката — добавена.
//
// Клетката е ръчна, а не декларативна `money` с `negative`, защото знакът се
// слага ПРЕД стойността, а надбавката вече идва отрицателна от BE —
// декларативният вариант даваше „−−2.40 €". Редът „Общо" минава през
// `meta.totalCell`, където знакът идва от самата сума и двоен минус е
// невъзможен.
//
// Отделен файл, а не локална функция в `discountsColumns`: файл, който изнася
// и компонент, и hook, чупи Fast Refresh (react-refresh/only-export-components).

import { fmtEuro } from "../../../../utils/currency";

/** Минус знак U+2212 — по-широк от дефиса и подравнен с цифрите. */
const MINUS = "−";

const MONO_NUMBER = "font-pos-mono text-[12.5px] tabular-nums";

type Props = {
  /** Отрицателна стойност = отстъпка, положителна = надбавка. */
  value: number;
};

export const AdjustmentAmount = ({ value }: Props) => {
  // Под половин цент няма какво да се чете като корекция — нулата се приглушава,
  // за да не спори с реалните суми в колоната.
  if (Math.abs(value) < 0.005) {
    return (
      <span className={`${MONO_NUMBER} font-semibold text-faint`}>
        {fmtEuro(0)}
      </span>
    );
  }

  const isDiscount = value < 0;
  return (
    <span
      className={`${MONO_NUMBER} font-bold ${
        isDiscount ? "text-danger-ink" : "text-info-deep"
      }`}
    >
      {isDiscount ? `${MINUS}${fmtEuro(-value)}` : `+${fmtEuro(value)}`}
    </span>
  );
};
